import Select from "react-select";

const SelectWithAdd = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  onAddNewClick,
  isClearable = true,
  isSearchable = true,
  error,
  required,
}) => {
  const extendedOptions = [
    ...(Array.isArray(options) ? options : []),
    { value: "add-new", label: "+ Add New" },
  ];

  const handleChange = (selected) => {
    if (selected?.value === "add-new") {
      onAddNewClick?.();
      return;
    }
    onChange(selected);
  };

  return (
    <div className="flex flex-col">
      {label && (
        <label className="text-sm font-medium text-slate-700 capitalize mb-1">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <Select
        options={extendedOptions}
        value={extendedOptions.find((opt) => opt.value === value) || null}
        onChange={handleChange}
        placeholder={placeholder || `Select...`}
        isClearable={isClearable}
        isSearchable={isSearchable}
        className="text-sm"
        menuPortalTarget={document.body}
        styles={{
          control: (provided) => ({
            ...provided,
            borderColor: error ? "red" : "#d1d5db",
            boxShadow: "none",
            "&:hover": { borderColor: error ? "red" : "#d1d5db" },
          }),
          menu: (provided) => ({
            ...provided,
            maxHeight: "200px",
            overflowY: "auto",
          }),

          menuList: (provided) => ({
            ...provided,
            maxHeight: "200px",
            overflowY: "auto",
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          option: (provided, { data }) => ({
            ...provided,
            backgroundColor:
              data.value === "add-new" ? "#F3F4F6" : provided.backgroundColor,
            fontWeight: data.value === "add-new" ? "bold" : "normal",
            cursor: "pointer",
            position: data.value === "add-new" ? "sticky" : "relative",
            bottom: data.value === "add-new" ? "0" : "auto",
          }),
        }}
      />
      {error && <span className="text-xs text-red-500 mt-1">{error}</span>}
    </div>
  );
};

export default SelectWithAdd;
